// /home/clement/compta-app/client/src/components/Finance/Budget/CreerBudget.js

import React from "react";

const CreerBudget = () => {
  return (
    <div className="creer-budget">
      <h2>Créer un budget</h2>
      <p>Formulaire de création de budget.</p>
    </div>
  );
};

export default CreerBudget;
